import { render, staticRenderFns } from "./ReportsNew.vue?vue&type=template&id=7406227a&scoped=true&"
import script from "./ReportsNew.vue?vue&type=script&lang=js&"
export * from "./ReportsNew.vue?vue&type=script&lang=js&"
import style0 from "./ReportsNew.vue?vue&type=style&index=0&id=7406227a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7406227a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7406227a')) {
      api.createRecord('7406227a', component.options)
    } else {
      api.reload('7406227a', component.options)
    }
    module.hot.accept("./ReportsNew.vue?vue&type=template&id=7406227a&scoped=true&", function () {
      api.rerender('7406227a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Brand/ReportsNew.vue"
export default component.exports